<template>
  <div class="contain">
    <div class="box">
      <template v-for="(item,key) in upload_list">
        <el-tooltip placement="top" :key="key" :content="item.filename">
          <div class="item">
            <div class="div" @click="upload_choose(key)">
              <img :src="item.url">
            </div>
            <div class="text">{{(item.size/1024).toFixed(2)+ 'KB'}}</div>
            <el-popconfirm title="确认删除？" @confirm="del(item.id,item.newname)">
              <div class="iconfont icon-close-circle" slot="reference"></div>
            </el-popconfirm>
          </div>
        </el-tooltip>
      </template>
      <div style="width: 100%;height: 60px;"></div>
    </div>
    <div class="bottom">
      <div class="left">
        <template v-for="(item,key) in choose_list">
          <div @click="unchoose(key)" :key="key">
            <el-tooltip placement="top" :content="item.filename">
              <img :src="item.url">
            </el-tooltip>
          </div>
        </template>
      </div>
      <el-button type="primary" size="small" class="mr-10" @click="confirm">确认</el-button>
      <el-upload class="upload-demo" :show-file-list="false"
                 :http-request="upload" :before-upload="upload_check"
                 accept="image/*">
        <el-button type="success" size="small">上传</el-button>
      </el-upload>
    </div>
  </div>
</template>

<script>
export default {
name: "upload-img",
  props:{
    isList : { type : Boolean, default :  false},
  },
  data(){
    return{
      upload_list:[],
      choose_list:[],
    }
  },
  mounted() {
    this.get_upload_list(this.user.uid);
  },
  methods:{
    get_upload_list:async function (uid){
      let rs = await this.$_api.company('upload_img', {uid : uid});
      if (rs.errcode == 0){
        this.upload_list = rs.data;
      }
    },
    upload_check:function (e){
      let that = this;
      console.log(e);
      let size = e.size / 1024 /1024;
      if (size > 5){
        that.$_showToastNone('最大只能上传5M');
        return false;
      }
    },
    upload:async function (e){
      console.log(e);
      try {
        if (e.file){
          this.$_showLoading();
          let res = await this.$_api.upload(e.file,'img','',this.user.uid);
          this.$_hideLoading();
          this.$_showToast(res.errmsg,res.style);
          this.get_upload_list(this.user.uid);
        }
      }catch (e) {
        console.log(e);
        return false;
      }
    },
    confirm:function (){
      if(this.choose_list.length == 0){
        this.$_showToastWarning('请选择图片');
        return;
      }
      let data = '';
      if(this.isList){
        data = this.choose_list;
      }else{
        data = this.choose_list[0];
      }
      this.$emit('submit',data);
    },
    upload_choose:function (index){
      let that = this;
      if(this.isList){
        that.choose_list.push(that.upload_list[index]);
      }else{
        that.choose_list = [that.upload_list[index]];
      }
    },
    unchoose:function (index){
      this.choose_list.splice(index,1);
    },
    del:async function (id,name){
      this.$_showLoading();
      let res = await this.$_api.company('upload_del',{id:id,name:name,table:'upload_img'});
      this.$_hideLoading();
      this.$_showToast(res.errmsg,res.style);
      if(res.errcode == 0){
        this.get_upload_list(this.user.uid);
      }
    }
  }
}
</script>

<style scoped>
.contain{
  width: 100%;
  height: 100%;
  position: relative;
}
.contain .box{
  display: flex;
  flex-wrap: wrap;
  height: 100%;
  overflow-y: auto;
}
.contain .item {
  width:calc((100% - 24px) / 3)px;
  height: 120px;
  margin: 0 22px 20px 0;
  cursor: pointer;
  position: relative;
}
.icon-close-circle{
  position: absolute;
  color: #dd524d;
  font-size: 20px;
  right: -2px;
  top: -2px;
}
.contain .div{
  width:100px;
  height: 100px;
  border: 1px solid #ccc;
  border-radius: 5px;
  position: relative;
}
.contain .choose{
  border: 1px solid #dd524d;
}
.contain img{
  width:100%;
  height: 100%;
  object-fit: contain;
}
.contain .item .text{
  margin-top: 3px;
  text-align: center;
  overflow: hidden;
  white-space: nowrap;
  text-overflow:ellipsis;
}
.contain .bottom{
  display: flex;
  align-items: center;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 50px;
}
.contain .bottom .left{
  flex:1;
  height: 100%;
  overflow: auto;
}
.contain .bottom .left div{
  display: inline-block;
  width:44px;
  height: 44px;
  border: 1px solid #dd524d;
  border-radius: 5px;
  margin-right: 10px;
}
</style>